import React from 'react'
import PropTypes from 'prop-types'
import { HEADER_HEIGHT, SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT } from '@CSSVars/variables'
import useMobileDetect from 'Hooks/useMobileDetect'
import { MOBILE_BREAK_POINT } from 'Defaults'

import {
  _DockSideContainer, _ChildContainer,
} from './styles'


const DockSide = ({
  children,
  dockIsOpen,
  winHeight,
  mobileBrowser,
  alertId,
  winWidth,
  drawActive,
  isMobileApp,
}) => {
  const { isIpad } = useMobileDetect()
  let childWrapperStyle

  // without this code, map will have extra space at the bottom which is mobile navigation height
  // which can cause mismatch number of listing count`
  if(winHeight && mobileBrowser && winWidth <= MOBILE_BREAK_POINT) {
    const headerHeight = Number(HEADER_HEIGHT && HEADER_HEIGHT.replace('px', ''))
    // 4 is border heights
    childWrapperStyle = {
      height: (
        winHeight
          - (isMobileApp ? 0 : headerHeight)
          - (drawActive ? 0 : SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT)
      ) + 'px',
    }
  }

  return (
    <_DockSideContainer
      id="dockSide"
      dockIsOpen={dockIsOpen}
    >
      <_ChildContainer
        isIpad={isIpad}
        withEditBar={alertId}
        isMobileApp={isMobileApp}
        fullHeight={drawActive}
        // className={childWrapperClasses}
        style={childWrapperStyle}
        winHeight={winHeight}
      >
        {children}
      </_ChildContainer>
    </_DockSideContainer>
  )
}

DockSide.propTypes = {
  children: PropTypes.node.isRequired,
  dockIsOpen: PropTypes.bool,
  map: PropTypes.shape({
    context: PropTypes.shape({}),
  }),
  alertId: PropTypes.string,
  mobileBrowser: PropTypes.bool,
  drawActive: PropTypes.bool,
  winHeight: PropTypes.number,
  winWidth: PropTypes.number,
  isMobileApp: PropTypes.bool,
}

export default DockSide
